// == Botón reutilizable ==
import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

// makeStyles con props dinámicas para el modo modoNaranja
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      color: 'white'
    }
  },
  modoNaranjaBtn: (p) => ({
    // Propiedades para el modo modoNaranja
    width: p.width || '125px',
    backgroundImage: `linear-gradient(45deg, ${p.gradientStart || 'rgb(251, 176, 64)'}, ${
      p.gradientEnd || 'rgb(241, 90, 41)'
    })`,
    color: 'white',
    // Evitamos que MUI sobreescriba con el color del "variant"
    '&.MuiButton-contained': {
      backgroundImage: `linear-gradient(45deg, ${p.gradientStart || 'rgb(251, 176, 64)'}, ${
        p.gradientEnd || 'rgb(241, 90, 41)'
      })`,
      backgroundColor: 'transparent'
    },
    '&:hover': {
      backgroundColor: p.hoverColor || '#083953'
    }
  })
}));

const CustomButton = (props) => {
  const {
    // Props originales (compatibilidad total)
    style,
    submit,
    color: colorProp,
    disabled,
    loading,
    onClick,
    size,
    disableRipple,
    children,
    // Props opcionales para el modo modoNaranja
    modoNaranja = false,
    label,
    habilitado = true,
    width,
    gradientStart,
    gradientEnd,
    hoverColor
  } = props;

  const classes = useStyles({ width, gradientStart, gradientEnd, hoverColor });

  // Mantener comportamiento original por defecto
  const color = colorProp ? colorProp : 'primary';

  // Cuando está en modo modoNaranja, deshabilitado si !habilitado o si loading/disabled
  const isDisabled = modoNaranja ? !habilitado || disabled || loading : disabled || loading;

  // Contenido: si hay children los respetamos; si no, usamos label
  const content = loading ? <CircularProgress color={modoNaranja ? 'inherit' : color} size={24} /> : children ?? label;

  return (
    <div className={classes.root}>
      <Button
        style={style}
        type={submit ? 'submit' : 'button'}
        variant="contained"
        // En modo modoNaranja evitamos el esquema de color del tema
        color={modoNaranja ? 'default' : color}
        disabled={isDisabled}
        onClick={onClick}
        size={size}
        disableRipple={disableRipple}
        className={modoNaranja ? classes.modoNaranjaBtn : undefined}
        disableElevation={modoNaranja ? true : undefined}
      >
        {content}
      </Button>
    </div>
  );
};

export default CustomButton;